/**
 * @generated SignedSource<<e5bc052ff38f6e510b919cffc787c801>>
 * @relayHash 11abe119a31a4d8643d0d34ab31914b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d894802d6e5ecfc3b98fd8bf27d6f5088628ba051a694ce861e7f3699deadfe6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentSettingsQuery } from './srcVirtualAgentSettingsQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d894802d6e5ecfc3b98fd8bf27d6f5088628ba051a694ce861e7f3699deadfe6",
    "metadata": {},
    "name": "srcVirtualAgentSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
